(function() {
  'use strict';

  angular.element(document).ready(function() {
    angular.bootstrap(document.querySelector('main'), ['NozzleSelector'], {
      strctDi: true
    });
  });

  angular.module('NozzleSelector.services', []);
  angular.module('NozzleSelector.directives', []);
  angular.module('NozzleSelector.controllers', ['NozzleSelector.services']);

  var appCoreDependencies = [
    'ui.router',
    'ng',
    'ngCookies',
    'ngStorage',
    'ngAria',
    'ngAnimate',
    'ngStorage',
    'ngMaterial',
    'ngSanitize',
    'angularSpinner',
    'served.templates',
    'pascalprecht.translate',
    'NozzleSelector.directives',
    'NozzleSelector.controllers'
  ];

  angular.module('NozzleSelector', appCoreDependencies);

  angular
    .module('NozzleSelector')
    .config(setRoutes)
    .config(setThemes)
    .config(setFonts)
    .config(setI18N)
    .config(mdSelectFix)
    .run(setEvents)
    .run(setLanguages) // tmp
    .run(setES6)
    .run(setConfig);

  /* @ngInject */
  function setRoutes($stateProvider, $urlRouterProvider, $compileProvider, $animateProvider, $mdGestureProvider) {
    console.log('setRoutes');
    
    $compileProvider.imgSrcSanitizationWhitelist('images/');
    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|chrome-extension):/);

    $animateProvider.classNameFilter(/^(?:(?!ng-animate-disabled).)*$/);
    
    $mdGestureProvider.skipClickHijack();
    
    var VIEWS_DIR = 'app/source/';

    $stateProvider
      .state('selector', {
        url: '/',
        controller: 'SelectorCtrl as vm',
        templateUrl: VIEWS_DIR + 'selector.view.html',
        data: {progress : 60}
      })
      .state('selector.results', {
        url: 'selector-results',
        templateUrl: VIEWS_DIR + 'results.view.html',
        data: {progress: 100},
        params: {ready: false}
      });

    $urlRouterProvider.otherwise('/');
  }

  /* @ngInject */
  function setEvents($rootScope, $state, $window) {
    console.log('setEvents');
    $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams, error) {

      //console.log(fromState, fromParams, toState, toParams);

      $rootScope.activated = false;
      $rootScope.progress = toState.data.progress;
      $rootScope.onHomepage = toState.name === 'selector';

      if (toState.name === 'selector.results' && !toParams.ready) {
        $state.go('selector', {reload: true});
      }

      // Scroll to the top
      window.scrollTo(0, 0);
    });
  }

  // @ngInject
  function setFonts($mdIconProvider) {
    console.log('setFonts');

    $mdIconProvider
      .defaultFontSet('FontAwesome')
      .fontSet('fa', 'FontAwesome');
  }
  
  // @ngInject
  function setI18N($translateProvider) {
    $translateProvider.useMissingTranslationHandlerLog();
    //$translateProvider.useSanitizeValueStrategy('sanitize');
    
    $translateProvider.useStaticFilesLoader({
      prefix: 'resources/locale-',// path to translations files
      suffix: '.json'// suffix, currently- extension of the translations
    });
    
    // is applied on first load
    $translateProvider.preferredLanguage('en_US');
    
    // saves selected language to localStorage
    $translateProvider.useLocalStorage();

    $translateProvider.forceAsyncReload(true);
  }
  
  // @ngInject
  function setThemes($mdThemingProvider, usSpinnerConfigProvider) {
    console.log('setThemes');

    var toroGrey = $mdThemingProvider.extendPalette('grey', {
      '50':'ffffff',
      '300': 'cccccc',
      '400': '999999',
      '500': 'cc0000', // brand color
      '600': '666666',
      '800': '333333',
      'contrastDefaultColor': 'light'
    });

    $mdThemingProvider.definePalette('toroGrey', toroGrey);

    $mdThemingProvider.theme('toroBrand')
      .primaryPalette('toroGrey', {
        'default': '500',
        'hue-1': '300',
        'hue-2': '800'
      });

    $mdThemingProvider.theme('dark').primaryPalette('toroGrey');
    $mdThemingProvider.setDefaultTheme('toroBrand');

    usSpinnerConfigProvider.setDefaults({color: 'red'});
  }

  // @ngInject
  function mdSelectFix($provide){
    $provide.decorator('$mdSelect',['$delegate','$timeout','$interval', function($delegate,$timeout,$interval) {
      var origShow = $delegate.show;
      var stop;
      $delegate.show = function(){
        var onShow = origShow.apply(this, arguments);
        onShow.then(function(){
          $interval.cancel(stop);
          stop = undefined;
        });
        var selectInput = arguments[0].target;
        var selectDropDown = arguments[0].element;
        
        angular.element(selectDropDown[0]).find('md-select-menu')[0].style.display = 'none';

        $timeout(function(){
          var boundings = selectInput.getBoundingClientRect();
          selectDropDown[0].style.left = boundings.left -15 + "px";
          selectDropDown[0].style.top = (boundings.top + boundings.height) + "px";
          var dropDownBoundings = selectDropDown[0].getBoundingClientRect();
          if(dropDownBoundings.width < boundings.width){
            selectDropDown[0].style.width = boundings.width + "px";
          }
          
          angular.element(selectDropDown[0]).find('md-select-menu')[0].style.display = '';
          
          stop = $interval(function(){
            selectDropDown[0].style.left = boundings.left - 15 + "px" ;
            selectDropDown[0].style.top = (boundings.top + boundings.height) + "px";
          },17);
        },60);
        
        return onShow;
      };

      return $delegate;
    }]);
  }
  
  /* @ngInject */
  function setLanguages($rootScope, $translate, i18nService) {
    console.log('setLanguage -', $translate.preferredLanguage());
    
    var currentLanguageKey = $translate.use() ||  $translate.storage().get($translate.storageKey()) || $translate.preferredLanguage();
    
    i18nService.getLanguages().then(function(data){
      var languages = data.data.languages;
      console.log('All langauges', languages);
      
      var currentLanguageIndex = 0;

      languages.forEach(function(l, index){
        if(l.code === currentLanguageKey) {currentLanguageIndex = index;}
      });

      $rootScope.languages = languages;
      $rootScope.currentLanguage = languages[currentLanguageIndex];

      console.log('Loaded language:', $rootScope.currentLanguage, 'index', currentLanguageIndex);
    });
    
    $rootScope.changeLanguage = function() {
      var selected = $rootScope.currentLanguage;
      console.log('Change language', selected);
      $translate.use(selected.code);
      $translate.preferredLanguage(selected.code);
    }

    $rootScope.trigerLanguageSelect = function (event) {
      angular.element(event.target.parentElement.children[2]).triggerHandler('click');
    }
  }

  /* @ngInject */
  function setConfig($rootScope, $translate) {
    console.log('setConfig');

    $rootScope.isLoading = true;
    
    // Loader
    
    $rootScope.$on('$translateChangeEnd', function(event) {
      $rootScope.isLoading = false; 
    });
  }

  /* @ngInject */
  function setES6() {

    /* Array.joinWith - shim by Joseph Myers 7/6/2013 */

    if (!Array.prototype.joinWith) {
      +(function() {
        Array.prototype.joinWith = function(that, by, select, omit) {
          var together = [], length = 0;
          if (select) select.map(function(x) {select[x] = 1;});
          function fields(it) {
            var f = {}, k;
            for (k in it) {
              if (!select) { f[k] = 1; continue; }
              if (omit ? !select[k] : select[k]) f[k] = 1;
            }
            return f;
          }
          function add(it) {
            var pkey = '.' + it[by], pobj = {};
            if (!together[pkey]) together[pkey] = pobj,
              together[length++] = pobj;
            pobj = together[pkey];
            for (var k in fields(it))
              pobj[k] = it[k];
          }
          this.map(add);
          that.map(add);
          return together;
        };
      }());
    }
  }

}());
